import React, {useContext} from 'react';

const AddressContext = React.createContext();

export const useAddressContext = () => useContext(AddressContext);

export default AddressContext;
